import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const connectionString =
    process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING?.trim();
// Unresolved release-pipeline tokens (e.g. local/dev builds) look like "#{Token}#" and are not a real connection string.
const appInsightsEnabled = Boolean(
    connectionString && !connectionString.startsWith('#{')
);

// Constructing ApplicationInsights without a connection string throws synchronously, so only build it when enabled.
let ai: ApplicationInsights | undefined;
if (appInsightsEnabled) {
    ai = new ApplicationInsights({
        config: {
            connectionString,
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: { history: browserHistory },
            },
            enableAutoRouteTracking: true,
        },
    });
    ai.loadAppInsights();
    ai.context.session.id = undefined;
}

const setSessionId = (newId: string | undefined) => {
    if (appInsightsEnabled && ai) {
        ai.context.session.id = newId;
    }
};

export const appInsights = ai?.appInsights;
export { reactPlugin, setSessionId, appInsightsEnabled };
